// /src/components/chat/shared/ChatHeader.js
import React, { useEffect } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import CloseIcon from '@mui/icons-material/Close';

const ChatHeader = ({
  customization,
  isMutedRef,
  soundEnabledRef,
  onToggleMute,
  onToggleMinimize,
  onToggleFontSize,
  onClose,
  isMaximized,
  isMuted,
  setIsMuted,
  devicePreview, // <-- add this prop
  hideMinimize
}) => {
  const chatControlIconColor = customization.chatControlIconColor || '#555555';

  // Update UI when mute state changes
  useEffect(() => {
    if (isMutedRef) {
      isMutedRef.current = isMuted;
    }
  }, [isMuted, isMutedRef]);
  return (
    <Box
      sx={{
        backgroundColor: customization.headerBackgroundColor,
        padding: devicePreview === 'desktop' ? '16px' : '30px 16px 16px 16px', // More top padding for phone/tablet
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderBottom: '1px solid #E8E8E8',
      }}
    >
      {customization.logo && (
        <img
          src={customization.logo}
          alt="Bot logo"
          style={{ maxWidth: '50px', height: 'auto' }}
        />
      )}
      <Typography variant="h6" sx={{ flexGrow: 1, color: customization.botTitleColor || 'inherit' }}>
        {customization.botTitle || 'Chat Bot'}
      </Typography>

      {soundEnabledRef.current && (
        <Tooltip title={isMuted ? "Unmute" : "Mute"}>
          <IconButton size="small" onClick={onToggleMute} sx={{ ml: -2, color: chatControlIconColor }}>
            {isMuted ? <VolumeOffIcon fontSize="small" sx={{ color: chatControlIconColor }} /> : <VolumeUpIcon fontSize="small" sx={{ color: chatControlIconColor }} />}
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="Change Font Size">
        <IconButton size="small" onClick={onToggleFontSize} sx={{ ml: -2, color: chatControlIconColor }}>
          <div style={{
            position: 'relative',
            width: '24px',
            height: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <span style={{ fontWeight: 'bold', color: chatControlIconColor }}>Aa</span>
          </div>
        </IconButton>
      </Tooltip>

      {!hideMinimize && (
        <Tooltip title="Minimize Chat">
          <IconButton size="small" onClick={onToggleMinimize} sx={{ ml: -2, color: chatControlIconColor }}>
            <span style={{ fontSize: '18px', lineHeight: '18px', display: 'inline-block', marginTop: '-2px', color: chatControlIconColor }}>−</span>
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="Close">
        <IconButton size="small" onClick={onClose} sx={{ ml: -2, color: chatControlIconColor }}>
          <span style={{ fontSize: '24px', color: chatControlIconColor }}>×</span>
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ChatHeader;
